import * as React from 'react';
import { Box, Grid, Typography, Tab, Tabs, FormControlLabel, Switch, Button } from '@mui/material';
import GlobalPopUp from '../../Components/global/globalPopUp/GLobalPopUp';
import TableComponent from '../../Components/tableComponent/tableComponent';
import { makeStyles } from 'tss-react/mui';
import agent from '../../API/apiCalls';
import { DashboardInfoContext, DashboardInfoPayload } from '../../Context/dashboardContext';
import { getLNIDlistRespModel } from "../../Models/tableDetailsModel"
import { UserContext, UserPayload } from '../../Context/userContext';
import tabStyles from './tabsPageStyles';
import TabPanel from '../../Components/tabPanel/tabPanel';
import { a11yProps } from '../../utils/a11yProps';

export default function BasicTabs() {
  const { classes } = tabStyles();
  const { maskButton, mask, tagStyle, firstTab, textStyle } = classes;
  const { setShowLoader } = React.useContext(UserContext) as UserPayload;
  const [value, setValue] = React.useState(0);
  const [lnidList, setLnidList] = React.useState<getLNIDlistRespModel[] | null>([])
  console.log("lnid list", lnidList)
  // const [toggleState, setToggleState] = React.useState(true);
  const [toggleState, setToggleState] = React.useState(lnidList !== null && lnidList[0]?.currentStatus === true ? true : false)
  const [subType, setSubType] = React.useState(lnidList !== null && lnidList[0]?.currentStatus === true ? "ON" : "OFF");
  console.log("subType", subType);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  console.log(";;;;;;;;", lnidList !== null && lnidList[0]?.currentStatus === true ? "ON" : "OFF")
  const handleChangeToggle = (event: string) => {
    // setSubType(event)
    setShowConfirmation(true);
  };
  const updateLNIDStatus = async () => {
    const response = await agent.UpdateLNIDStatus.put();
    if (response.flagStatus) {
      if (subType == "ON") {
        setSubType("OFF")
      } else {
        setSubType("ON")
      }
      setToggleState(!toggleState);
      setShowConfirmation(false);
    }

  }
  const getLNIDList = async () => {
    setShowLoader(true);
    const response = await agent.GetLNIDList.get()
    setLnidList(response.value.sort((a: any, b: any) => new Date(b.updatedOn).valueOf() - new Date(a.updatedOn).valueOf()))
    setSubType(response.value.sort((a: any, b: any) => new Date(b.updatedOn).valueOf() - new Date(a.updatedOn).valueOf())[0].currentStatus === true ? "ON" : "OFF")
    setShowLoader(false);
  }

  const handleConfirmation = () => {
    updateLNIDStatus();
  };
  React.useEffect(() => {
    console.log("lnid list")
  }, [lnidList])
  console.log("toggleButton", toggleState)
  React.useEffect(() => {
    getLNIDList()
  }, [toggleState])
  return (
    <>
      <GlobalPopUp
        HandleLnidThreePsChange={handleConfirmation}
        heading="LNID Confirmation"
        message={`Are you sure you want to ${lnidList !== null ?
            lnidList[0]?.currentStatus ? 'Off' : 'On'
            : 'Off'
          } LNID config?`}
        flagPopUp={showConfirmation}
        setflagPopUp={setShowConfirmation}
        section="changeLNID"
      />
      <Grid container direction="column"
        // justifyContent="space-between" 
        sx={{ height: '100%', flexWrap: 'nowrap' }}>
        <Grid item>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs sx={{ padding: '0px' }} value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab className={firstTab} sx={{ fontWeight: "600", fontSize: "15px", width: "35px" }} label="LNID" {...a11yProps(0)} />
                <Tab sx={{ textTransform: 'unset', fontWeight: "600", color: "#7A7A7A", fontSize: "15px" }} label="Others" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid container alignItems="center">
                <Grid item className={tagStyle}>LNID</Grid>
                <Grid item sx={{ marginLeft: '160px' }}>
                  <Box sx={{ display: "flex" }}>
                    <Box className={maskButton}>
                      <Box
                        className={mask}
                        style={{
                          transform: `translateX(${subType === "ON" ? 0 : "58px"})`
                        }}
                      />
                      <Button
                        disableRipple
                        variant="text"
                        sx={{ color: subType === "ON" ? "#fff" : "#000", textTransform: "unset", fontSize: "13px" }}
                        // onClick={() => setSubType("ON")}
                        onClick={() => handleChangeToggle("ON")}
                      >
                        ON
                      </Button>
                      <Button
                        disableRipple
                        variant="text"
                        sx={{ color: subType === "OFF" ? "#fff" : "#000", textTransform: "unset", fontSize: "13px" }}
                        onClick={() => handleChangeToggle("ON")}
                      // onClick={() => setSubType("OFF")}
                      >
                        OFF
                      </Button>
                    </Box>
                  </Box>
                  {/* <FormControlLabel control={<Switch checked={toggleState} onChange={handleChangeToggle} name="On" />} label="On" /> */}
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
              Others
            </TabPanel>
          </Box>
        </Grid>
        {value === 0 && (
          <Grid item sx={{ marginTop: "20px" }}>
            <Box className={textStyle}>LNID Last 10 Entries</Box>
            <TableComponent rows={lnidList?.slice(0, 10)} />
          </Grid>
        )}
      </Grid>
    </>
  );
}


